module.exports = __webpack_public_path__ + "img/lose_day.64509157.png";